import React, { useState, useEffect } from "react";
import { Box, Typography, Card, useTheme, Container } from "@mui/material";
import { Helmet } from "react-helmet";
import PositionsTable from "./PositionsTable";
import { getPositions } from "../../utils/helpers";
import { usePositionsState } from "../../hooks/useOptimizedState";
const Positions = () => {
  const theme = useTheme();
  const { funds, lots, strategies, custodians, accountingData, managers } = usePositionsState();

  const [positions, setPositions] = useState([]);
  const [filteredPositions, setFilteredPositions] = useState([]);

  // Filter out SMA funds and lots
  const fund = accountingData[0]?.funds;
  const smaList = Object.keys(managers[0]?.smas || {});
  const filteredFunds =
    funds?.filter((fund) => !smaList?.includes(fund?.fundId)) || [];
  const filteredLots =
    lots?.filter((lot) => !smaList?.includes(lot?.fund)) || [];
  const filteredFund = fund?.filter((f) => !smaList?.includes(f?.fund)) || [];

  useEffect(() => {
    if (funds && lots && strategies && custodians) {
      const positionsData = getPositions(
        filteredFunds,
        strategies,
        filteredLots,
        custodians
      );
      setPositions(positionsData);
      setFilteredPositions(positionsData);
    }
  }, [funds, lots, strategies, custodians, managers]);

  return (
    <>
      <Helmet>
        <title>Positions | Vantage Alpha</title>
      </Helmet>
      <Box
        sx={{
          backgroundColor: theme.palette.grey[50],
          minHeight: "100vh",
          py: 3,
        }}
      >
        <Container maxWidth="xl">
          <Box sx={{ mb: 3 }}>
            <Typography
              variant="h4"
              sx={{
                fontWeight: 600,
                color: theme.palette.text.primary,
                mb: 1,
              }}
            >
              Positions
            </Typography>
            <Typography
              variant="body1"
              sx={{
                color: theme.palette.text.secondary,
              }}
            >
              View and manage portfolio positions across funds and strategies
            </Typography>
          </Box>

          <Card
            sx={{
              borderRadius: 2,
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              border: `1px solid ${theme.palette.divider}`,
            }}
          >
            <PositionsTable 
              positions={filteredPositions}
              originalPositions={positions}
              funds={filteredFunds}
              strategies={strategies}
              custodians={custodians}
            />
          </Card>
        </Container>
      </Box>
    </>
  );
};

export default Positions; 